module.exports = __webpack_public_path__ + "static/assets/ee096006c86627ddbda7268203d7e50b.svg";